<template>
  <q-form ref="form" class="full-width q-px-md">
    <div class="row">
      <div class="col-12 col-sm-6 col-md-4 q-pa-xs">
        <q-input
          v-model="formData.number"
          label="Number"
          v-bind="siteCFG.fields.general"
        >
        </q-input>
      </div>
      <div class="col-12 col-sm-6 col-md-4 q-pa-xs">
        <q-select
          v-model="formData.code"
          label="Code"
          v-bind="siteCFG.fields.general"
          :options="dqCodes"
        >
        </q-select>
      </div>
      <div class="col-12 col-md-4 q-pa-xs">
        <q-select
          v-model="formData.type"
          label="Type"
          v-bind="siteCFG.fields.general"
          :options="dqTypes[formData.code]"
          use-input
          input-debounce="0"
          new-value-mode="add"
        >
        </q-select>
      </div>
      <div class="col-12 q-pa-xs">
        <autocomplete
          label="Disciplines"
          :id="formData.disciplines_id"
          :items="disciplines"
          :itemsLoading="disciplinesLoading"
          option_label="discipline_name"
          option_value="id"
          clearable
          multiple
          useChips
          @changed="
            val => {
              formData.disciplines_id = val;
            }
          "
        />
        <!-- <assignDiscipline
          :id="formData.disciplines_id"
          @changed="(val) => (formData.disciplines_id = val)"
        /> -->
      </div>
      <div class="col-12 q-pa-xs">
        <q-input
          v-model="formData.description"
          label="Description"
          type="textarea"
          v-bind="siteCFG.fields.general"
        >
        </q-input>
      </div>
    </div>
  </q-form>
</template>

<script>
import { mapGetters } from "vuex";
import competitionFormVue from "../competitions/competitionForm.vue";
import assignDiscipline from "@/components/disciplines/assignDiscipline.vue";
import autocomplete from "@/components/wrappers/autocomplete/autocomplete.vue";

export default {
  components: { assignDiscipline, autocomplete },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
      currentUserData: "auth/currentUserData",
      siteCFG: "settings/siteCFG",
      data: "dqCodes/current",
      dataLoading: "dqCodes/currentLoading",
      dqCodes: "settings/dqCodes",
      dqTypes: "settings/dqTypes",
      disciplines: "disciplines/list",
      disciplinesLoading: "disciplines/listLoading"
    })
  },
  props: {
    id: {
      default: null
    }
  },
  watch: {
    id: function() {
      this.init();
    },
    data: function() {
      this.init();
    }
  },
  data: () => ({
    // Extra Data
    formData: {
      code: "DQ",
      disciplines_id: []
    },
    tab: "general"
  }),
  beforeCreate() {},
  mounted() {
    this.init();
    this.$store.dispatch("dqCodes/loadByID", this.id);
    this.$store.dispatch("settings/loadDQTypes");
    this.$store.dispatch("disciplines/loadAll");
  },
  methods: {
    init() {
      if (this.data != null && this.data.id == this.id) {
        this.formData = JSON.parse(JSON.stringify(this.data));
        this.formData.disciplines_id = this.formData.disciplines_id.split(",");
        this.formData.disciplines_id = this.formData.disciplines_id.map(str => {
          return Number(str);
        });
        console.log(this.formData.disciplines_id);
      } else {
        this.formData = {
          code: "DQ"
        };
      }
    },
    create() {
      this.$emit("loadingStateChanged", true);
      this.$refs.form.validate().then(result => {
        if (result) {
          let payload = JSON.parse(JSON.stringify(this.formData));
          payload.disciplines_id = payload.disciplines_id
            ? payload.disciplines_id.toString()
            : [];
          this.$store.dispatch("dqCodes/new", payload).then(result => {
            this.$emit("loadingStateChanged", false);
            if (result.Result == "Success") {
              this.$emit("close", true);
              this.formData = {};
              this.$q.notify({
                position: "top-right",
                type: "positive",
                message: result.Response.Message
              });
            } else {
              this.$q.notify({
                position: "top-right",
                type: "negative",
                message: result.Response.Message
              });
            }
          });
        } else {
          this.$emit("loadingStateChanged", false);
        }
      });
    },
    save() {
      this.$emit("loadingStateChanged", true);
      let payload = JSON.parse(JSON.stringify(this.formData));
      payload.disciplines_id = payload.disciplines_id
        ? payload.disciplines_id.toString()
        : null;

      this.$store.dispatch("dqCodes/save", payload).then(result => {
        this.$emit("loadingStateChanged", false);
        if (result.Result == "Success") {
          this.address = "";
          this.$emit("close", true);
          this.$q.notify({
            position: "top-right",
            type: "positive",
            message: result.Response.Message
          });
        } else {
          this.$q.notify({
            position: "top-right",
            type: "negative",
            message: "There was an Error, Please try again later"
          });
        }
      });
    },
    isIndividualDiscipline() {
      this.formData.isTeamDiscipline =
        this.formData.isTeamDiscipline == 0 ? 1 : 0;
      this.formData.teamSizeMin = 1;
      this.formData.teamSizeMax = 1;
    },
    isTeamDiscipline() {
      this.formData.isIndividualDiscipline =
        this.formData.isIndividualDiscipline == 0 ? 1 : 0;
    }
  }
};
</script>

<style lang="scss" scoped>
.formSubTitle {
  font-weight: bold;
}
</style>
